/* ── GPU / device quality tier ────────────────────────────
   Cheap heuristics only — no benchmark stalls on startup.
   "low" keeps old PCs and phones smooth: capped DPR, fewer
   particles, no antialiasing, simpler world. */

export function detectTier() {
  if (typeof window === "undefined") return "low";

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) return "low";

  const cores = navigator.hardwareConcurrency || 2;
  const memory = navigator.deviceMemory || 4; // GB, Chrome only
  const mobile = window.matchMedia("(pointer: coarse)").matches;

  if (mobile || cores <= 4 || memory <= 4) return "low";
  return "high";
}

export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
